import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { environment, FAKE_DB_COLLECTIONS_TOKEN } from '@mri-platform/shared/core';
import { EntityServices, ENTITY_METADATA_TOKEN, PLURAL_NAMES_TOKEN } from '@ngrx/data';
import {
  AccessTokenEntityService,
  ApiEntityService,
  DataSourceClientEntityService,
  DataSourceEntityService,
  entityMetadata,
  FileDataEntityService,
  MetaDataEntityService,
  pluralNames,
  RefreshApiHistoryEntityService
} from './data-access';
import { devDb } from './testing/dev-dataset';
import { testDb } from './testing/test-dataset';

@NgModule({
  imports: [CommonModule],
  providers: [
    { provide: PLURAL_NAMES_TOKEN, multi: true, useValue: pluralNames },
    { provide: ENTITY_METADATA_TOKEN, multi: true, useValue: entityMetadata },
    { provide: FAKE_DB_COLLECTIONS_TOKEN, multi: true, useValue: environment.dev ? devDb : testDb }
  ]
})
export class CommonStateModule {
  constructor(
    entityServices: EntityServices,
    accessTokenEntityService: AccessTokenEntityService,
    connectionEntityService: ApiEntityService,
    dataSourceEntityService: DataSourceEntityService,
    dataSourceClientEntityService: DataSourceClientEntityService,
    metaDataEntityService: MetaDataEntityService,
    refreshApiHistoryEntityService: RefreshApiHistoryEntityService,
    fileDataEntityService: FileDataEntityService
  ) {
    entityServices.registerEntityCollectionServices([
      accessTokenEntityService,
      connectionEntityService,
      dataSourceEntityService,
      dataSourceClientEntityService,
      metaDataEntityService,
      refreshApiHistoryEntityService,
      fileDataEntityService
    ]);
  }
}
